import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Value = styled.div.withConfig({
  displayName: "partials__Value",
  componentId: "sc-15bw4qe-0"
})(["display:flex;"]);
var iconSize = 24;
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-15bw4qe-1"
})(["svg{display:block;width:", "px;height:", "px;}"], iconSize, iconSize);
export var ValueColumn = styled.div.withConfig({
  displayName: "partials__ValueColumn",
  componentId: "sc-15bw4qe-2"
})(["margin-left:auto;margin-right:12px;font-weight:700;", ""], fontSmoothing);
export var BarBlock = styled.div.withConfig({
  displayName: "partials__BarBlock",
  componentId: "sc-15bw4qe-3"
})(["display:flex;align-items:center;width:90px;", ";", ";"], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 120px;\n  "]))), minMediaQueries.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 180px;\n  "]))));
export var Bar = styled.div.withConfig({
  displayName: "partials__Bar",
  componentId: "sc-15bw4qe-4"
})(["width:", "%;height:9px;border-radius:8px;background-color:", ";"], function (_ref) {
  var value = _ref.value;
  return value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryM;
});
export var FooterDate = styled.div.withConfig({
  displayName: "partials__FooterDate",
  componentId: "sc-15bw4qe-5"
})(["margin-top:9px;"]);